import React from "react";

export const RUMO_PISTA_HELP_TITLE = "Rumo de Pista A-B";

export function RumoPistaHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Definir a{" "}
        <strong>direção oficial do trabalho</strong> no talhão — pontos A e B —
        para o piloto automático seguir o sentido correto, evitando linhas
        invertidas ou rumo oposto ao planejado.
      </p>

      <p>
        <strong>Melhor forma de fazer o rumo A-B:</strong> use o{" "}
        <strong>Mapa da fazenda</strong>. Lá você marca os pontos A e B, salva
        o rumo no talhão e publica. O operador passa a ver a mesma referência
        no <strong>mapa da fazenda do app de campo</strong>, junto com os
        demais desenhos.
      </p>

      <p>
        <strong>Esta tela (Rumo de Pista A-B):</strong> é o atalho para{" "}
        <strong>tirar um print e enviar direto</strong> ao operador — WhatsApp,
        rádio ou mensagem — quando você <strong>não quiser salvar</strong> o
        rumo no mapa da fazenda. Não substitui o mapa: o rumo daqui não fica
        gravado no talhão nem aparece automaticamente no app.
      </p>

      <p>
        <strong>Como usar nesta tela:</strong>
      </p>
      <ol>
        <li>
          Abra o mapa satélite e aumente o zoom ao máximo para precisão.
        </li>
        <li>
          Clique para marcar o <strong>Ponto A</strong> (início da referência).
        </li>
        <li>
          Clique para marcar o <strong>Ponto B</strong> (sentido do trabalho A
          → B).
        </li>
        <li>Arraste A ou B se precisar ajustar a posição.</li>
        <li>
          Copie <strong>latitude, longitude</strong>, <strong>rumo (°)</strong>{" "}
          e distância, ou salve uma captura de tela para mandar ao operador.
        </li>
      </ol>

      <p>
        <strong>Quando usar:</strong> plantio, pulverização ou preparo em que a
        direção das passadas importa. Se o rumo for reutilizado, prefira
        gravar no <strong>Mapa da fazenda</strong>. Use esta tela para um
        envio rápido, só com o print.
      </p>

      <p>
        <strong>Importante:</strong> cada fabricante de piloto pode exigir
        formato diferente. Esta ferramenta gera ponto A, ponto B e{" "}
        <strong>rumo (°)</strong> em graus — formato adequado ao sistema{" "}
        <strong>JACTO</strong>. Confira o manual da máquina antes de digitar no
        display.
      </p>
    </>
  );
}
